import actionTypes from "#/redux/actions/actionTypes"
import { fetchReimbursementDetails } from "./reimbursementDetailsActions"
import { fetchUserInfo } from "./userActions"
import { createRequestAction } from "#/redux/actions/shared"
import {
  resetHasCheckInModalTriggeredThisSession,
  resetHasCrrModalTriggeredThisSession,
  resetHasJourneyChangeModalTriggeredThisSession
} from "#/components/views/modal/utils/localStorageUtils"
import { carrotClient } from "#/utils/CarrotClient"

export const fetchReduxData = () => async (dispatch: any) => {
  dispatch({ type: actionTypes.FETCH_IS_LOGGED_IN_REQUEST })

  if (!(await isUserLoggedIn())) {
    dispatch({ type: actionTypes.FETCH_IS_LOGGED_IN_FAILURE })
    return
  }

  dispatch({ type: actionTypes.FETCH_IS_LOGGED_IN_SUCCESS })

  const reduxDataActions = [fetchUserInfo, fetchReimbursementDetails]
  reduxDataActions.forEach((action) => {
    Promise.resolve(dispatch(action())).catch(() => {})
  })
}

async function isUserLoggedIn(): Promise<boolean> {
  try {
    const response = await carrotClient.getIsUserLoggedIn()
    return response.isLoggedIn === true
  } catch {
    return false
  }
}

export const signIn = () => async (dispatch: any) => {
  await dispatch({
    type: actionTypes.SIGN_IN
  })

  resetHasCrrModalTriggeredThisSession()
  resetHasJourneyChangeModalTriggeredThisSession()
  resetHasCheckInModalTriggeredThisSession()

  dispatch(fetchReduxData())
}

export const signOut = createRequestAction("FETCH_SIGN_OUT", carrotClient.logout.bind(carrotClient))

export const persistEmail = (email: any) => async (dispatch: any) => {
  await dispatch({
    type: actionTypes.PERSIST_EMAIL,
    payload: email
  })
}
